// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1872":"751656ae","5848":"751656ae"}[chunkId] + ".chunk.css";
};